import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'menu-2', 'Menu2', [["path",{"d":"M4 6l16 0"}],["path",{"d":"M4 12l16 0"}],["path",{"d":"M4 18l16 0"}]]);